import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
const responseParser = (response: any) => {
  console.log('htag response', response)
  const data = isSuccessResponse(response)
  console.log('htag data', data)
  return data
}
const updateDeviceStatusApi = (reqBody, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.updateDeviceStatusApi),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    //headers: { ...getHeaders(), 'x-user-id': 'test', 'x-channel-id': '322287787654' },
    body: reqBody,
  }
  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}
export { updateDeviceStatusApi }
